import curry from "ramda/es/curry";
import evolve from "ramda/es/evolve";
import keys from "ramda/es/keys";
import pickAll from "ramda/es/pickAll";
/**
 * Transforms object based on map of transformations.
 *
 * @documented
 * @category Object
 * @param {Object} transformation object with transformation functions
 * @param {Object} data object with values for transformations
 * @returns {Object} object with transformed values
 *
 * @example
 *
 *      const data = {
 *			key1: ' 1',
 *			key2: ' 1',
 *			key3: ' 1',
 *		};
 *		const transformations = {
 *			key1: trim,
 *			key2: trim,
 *			key4: always('aaa'),
 *		};
 *		evolvePicked(transformations, data)
 *		// {
 *		//	key1: '1',
 *		//	key2: '1',
 *		//	key4: 'aaa',
 *		// };
 *
 */ const evolvePickedAll = curry((transformation, data)=>{
    return evolve(transformation, pickAll(keys(transformation), data));
});
export default evolvePickedAll;
